// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2DR1M","colBig":"styles_colBig__2Ey94","colSmall":"styles_colSmall__3X3GE"};